import Icon from "../components/Elements/Icon/Icon"
import { AuthRouter } from "../router/Router"
import Images from "./images"
import React from "react"
export const sidebarItems = [
  {
    id: 1,
    label: "ROI Estimate",
    roleId: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    path: AuthRouter[0].subpath,
    icon: <Icon src={Images.ActiveEstimate} alt={"home"} />,
    activeIcon: <Icon src={Images.RoiEstimate} alt={"home_active"}></Icon>,
  },

  {
    id: 4,
    roleId: [1, 2, 3, 4, 7,8],
    isCheckUserPermissionId: [2,12],
    label: "Manage Users",
    icon: <img src={Images.ManageUser} alt={"home"} />,
    activeIcon: <Icon src={Images.activeManageUser} alt={"home_active"}></Icon>,
    path: AuthRouter[2].subpath,
  },
  {
    id: 5,
    roleId: [1],
    label: "Partners",
    isCheckUserPermissionId: [3],
    icon: <img src={Images.partner} alt={"home"} />,
    activeIcon: <img src={Images.partneractive} alt={"home_active"} />,
    path: AuthRouter[7].subpath,
  },
  // {
  //   id: 8,
  //   roleId: [2,7],
  //   label: "Federal Partners",
  //   isCheckUserPermissionId: [3],
  //   icon: <img src={Images.partner} alt={"home"} />,
  //   path: AuthRouter[13].subpath,
  // },
   {
    id: 9,
    roleId: [2],
    label: "Partners",
    isCheckUserPermissionId: [3],
    icon: <img src={Images.partner} alt={"home"} />,
    path: AuthRouter[7].subpath,
  },
  {
    id: 5,
    roleId: [5, 6],
    label: "Manage Users",
    isCheckUserPermissionId: [5, 8],
    icon: <img src={Images.partner} alt={"home"} />,
    activeIcon: <Icon src={Images.partneractive} alt={"home_active"}></Icon>,
    path: AuthRouter[9].subpath,
  },
  {
    id: 2,
    roleId: [1, 2, 3, 4, 5, 6],
    label: "Configuration",
    isCheckUserPermissionId: [1],
    IsDropdown:true,
    Text: "Admin",
    icon: <img src={Images.administration} alt={"home"} />,
    activeIcon: <Icon src={Images.ActiveAdmin} alt={"home_active"}></Icon>,
    subMenus: [
      {
        label: "Industry Configuration",
        path: AuthRouter[3].subpath,
      },
      {
        label: "Manage Currencies",
        path: AuthRouter[11].subpath,        
      },
      {
        id: 3,
        roleId: [1],
        label: "Manage Roles",
        icon: <img src={Images.ManageRoles} alt={"home"} />,
        activeIcon: (
          <Icon src={Images.ManageRolesactive} alt={"home_active"}></Icon>
        ),
        path: AuthRouter[8].subpath,
      },
      {
        id: 3,
        roleId: [1],
        label: "Manage Products",
        icon: <img src={Images.ManageRoles} alt={"home"} />,
        activeIcon: (
          <Icon src={Images.ManageRolesactive} alt={"home_active"}></Icon>
        ),
        path: AuthRouter[12].subpath,
      },
    ],
  },
  {
    id: 7,
    roleId: [1, 2, 3, 4, 5, 6,7],
    label: "Federal Configuration",
    Text: "Federal",
    isCheckUserPermissionId: [1,12],
    icon: <img src={Images.FederalConfiguration} alt={"home"} />,
    activeIcon: <Icon src={Images.FederalConfiguration} alt={"home_active"}></Icon>,
    path: AuthRouter[14].subpath,
  },
  {
    id: 6,
    roleId: [5, 6],
    label: "PDF Branding",
    isCheckUserPermissionId: [4, 9],
    icon: <Icon src={Images.PdfBranding} alt={"home"} />,
    activeIcon: <Icon src={Images.activepdfbranding} alt={"home_active"}></Icon>,
    path: AuthRouter[10].subpath,
  },
]
export const sidebarUserGuide = [
  {
    id: 4,
    label:"Step by Step Guide",
    path: "/Userguide",
    icon: <Icon src={Images.Userguide} alt={""} />,
    // ClassNames:"Step by Step Guide"
  },
]
export const sidebarLast = [
  {
    id: 5,
    label: "Logout",
    path: "/logout",
    icon: <Icon src={Images.logout} alt={"home"} />,
  },
]
